// extracted by mini-css-extract-plugin
export default {"score":"Score_score__otrbb","score__heading":"Score_score__heading__lao1d","score__value":"Score_score__value__zp8bD","bump":"Score_bump__iQekK"};